import * as types from './types';

const result = (type, payload) => {
  return {
    type: type,
    payload: payload,
  };
};

export const getWorksFields = (payload) =>
  result(types.GET_WORKS_FIELDS, payload);
export const getWorksFieldsSuccess = (payload) =>
  result(types.GET_WORKS_FIELDS_SUCCESS, payload);
export const getWorksFieldsError = (payload) =>
  result(types.GET_WORKS_FIELDS_ERROR, payload);

export const getCities = (payload) => result(types.GET_CITIES, payload);
export const getCitiesSuccess = (payload) =>
  result(types.GET_CITIES_SUCCESS, payload);
export const getCitiesError = (payload) =>
  result(types.GET_CITIES_ERROR, payload);

export const getEducationsLevels = (payload) =>
  result(types.GET_EDUCATIONS_LEVEL, payload);
export const getEducationsLevelsSuccess = (payload) =>
  result(types.GET_EDUCATIONS_LEVEL_SUCCESS, payload);
export const getEducationsLevelsError = (payload) =>
  result(types.GET_EDUCATIONS_LEVEL_ERROR, payload);

export const getDocumentsTypes = (payload) =>
  result(types.GET_DOCUMENTS_TYPES, payload);
export const getDocumentsTypesSuccess = (payload) =>
  result(types.GET_DOCUMENTS_TYPES_SUCCESS, payload);
export const getDocumentsTypesError = (payload) =>
  result(types.GET_DOCUMENTS_TYPES_ERROR, payload);
